import React, { createContext, useState, useEffect, useContext } from 'react';

// Cria o Contexto de Autenticação
export const AuthContext = createContext(null);

// Componente Provedor de Autenticação
export const AuthProvider = ({ children }) => {
    const [authToken, setAuthToken] = useState(localStorage.getItem('jwtToken'));
    const [participanteId, setParticipanteId] = useState(localStorage.getItem('participanteId'));
    const [participanteNome, setParticipanteNome] = useState(localStorage.getItem('participanteNome'));
    const [participanteRole, setParticipanteRole] = useState(localStorage.getItem('participanteRole') || ''); // <--- Adicione o estado para a role


    // Efeito para sincronizar o estado do contexto com o localStorage
    useEffect(() => {
        // Sincroniza o authToken
        if (authToken) {
            localStorage.setItem('jwtToken', authToken);
        } else {
            localStorage.removeItem('jwtToken');
        }

        // Sincroniza o participanteId
        if (participanteId) {
            localStorage.setItem('participanteId', participanteId);
        } else {
            localStorage.removeItem('participanteId');
        }

        // Sincroniza o participanteNome
        if (participanteNome) {
            localStorage.setItem('participanteNome', participanteNome);
        } else {
            localStorage.removeItem('participanteNome');
        }

        // Sincroniza o participanteRole
        if (participanteRole) { // <--- Adicione a lógica para a role
            localStorage.setItem('participanteRole', participanteRole);
        } else {
            localStorage.removeItem('participanteRole');
        }

    }, [authToken, participanteId, participanteNome, participanteRole]); // Dependências do useEffect

    // Função de Login
    const login = (jwt, id, nome, role) => {
        setAuthToken(jwt);
        setParticipanteId(id);
        setParticipanteNome(nome);
        setParticipanteRole(role);
    };

    // Função de Logout
    const logout = () => {
        setAuthToken(null);
        setParticipanteId(null);
        setParticipanteNome(null);
        setParticipanteRole(null);
        localStorage.clear(); // Limpa todo o localStorage relacionado à sessão
    };

    // Valor que será provido para os componentes filhos
    const value = {
        authToken,
        participanteId,
        participanteNome,
        participanteRole,
        isAuthenticated: !!authToken, // Booleano para verificar se está autenticado
        login,
        logout,
    };

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

// Hook personalizado para facilitar o consumo do contexto
export const useAuth = () => {
    return useContext(AuthContext);
};